import {Component, OnInit} from '@angular/core';

declare var $: any;
@Component({
  selector: 'app-setting',
  templateUrl: 'setting.template.html',
  styleUrls: ['./business.css'],
  providers: [],
})
export class SettingComponent implements OnInit {
  public activeTab: Number = 1;

  constructor() {
  }

  ngOnInit() {
    this.activeTabSetting();
  }

  activeTabSetting() {
    const header = document.getElementById('menu-content-setting');
    const btns = header.getElementsByClassName('menu-content-item');
    for (let i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        const current = document.getElementsByClassName('active');
        if (current.length > 0) {
          current[0].className = current[0].className.replace(' active', '');
        }
        this.className += ' active';
      });
    }
  }

  changeSetting(value: any) {
    this.activeTab = value
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/setting.component.ts